import { CollapsedTagList } from '@/components/CollapsedTagList';
import i18n from '@/i18n';
import { type ModelCapabilityModalityKey, getModelCapabilityLabel } from '@/types/model-capabilities';

/** 渲染模型类型标签列表 */
export function renderModelCategoryTags(category?: ModelCapabilityModalityKey[]) {
  if (!Array.isArray(category) || !category.length) return '-';
  return <CollapsedTagList items={category.map((item) => getModelCapabilityLabel(item))} popoverTitle={i18n.t('data-center:model.type')} />;
}
